import React from 'react';
import { withRouter } from 'react-router-dom'
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import Swal from 'sweetalert2'
import axios from 'axios';
import { API_MOSA_URL, ACCESS_TOKEN_NAME } from '../constants/apiContants';
import LoadingOverlay from 'react-loading-overlay';
import "./dashboard.css";
import moment from 'moment';
import store from "../store/index";
import i18n from '../i18n';
const devicedetails = {
    "imei": "862188038288320",
    "deviceOSVersion": "6.0.1",
    "uuid": "862188038288320",
    "deviceModel": "NOKIA 100",
    "deviceManufacturer": "Xiaomi",
    "serviceProvider": "airtel",
    "deviceOS": "ANDROID",
    "ipAddress": "192.168.43.210"
}
const headers = {
    "RequestMode": "0",
    "UserID": localStorage.getItem('userid'),
    "BearerKey": "Mobile",
    "ServiceId": "SERV!",
    "SessionId": localStorage.getItem(ACCESS_TOKEN_NAME),
    "Locale": "E/A",
    "DeviceDet": devicedetails

}

class UserProfile extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tabIndex: 0,
            events: [],
            page: 1,
            events: [],
            email: localStorage.getItem('userEmail'),
            mobile: localStorage.getItem('userPhone')
        };
        this.setState = this.setState.bind(this);
        this.setTabIndexDetails = this.setTabIndexDetails.bind(this);
        this.eventDetails = this.eventDetails.bind(this);

    }
    setTabIndexDetails = (event, index) => {
        console.log(index);
        this.setState({ tabIndex: index });
    }
    myChangeHandler = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    }
    // handelOnUploadFile = (event) => {
    //   console.log("File ::: " + JSON.stringify(event.target.files[0]));
    //   this.setState({
    //     document: event.target.files[0]
    //   })
    // }
    getFiles(file) {
        this.setState({ document: file })
    }
    getFilesDoc(file) {
        this.setState({ documentId: file })
    }
    handleMembership = () => {



        const payload = {
            "membership_type": "STUDENT",
            "name": "Sreekanth",
            "nationality_id": "OMAN",
            "dob": "05/02/1990",
            "work_place": "WATTAYA",
            "occupation": "SOFTWARE ENGINEER",
            "resident_place": "RUWI",
            "mobile_no": "97009700",
            "email_id": "sree@gmail.com",
            "gender": "MALE",
            "duration": "6"

        }

        // redirectToHome();
        const mosa = { "mast": payload, ReqHead: headers }
        // console.log('calling api ...' + JSON.stringify(payload));
        let self = this; //  declared var welcom

        console.log('calling api ...' + JSON.stringify(mosa));
        this.setState({ isActive: true });

        axios.post(API_MOSA_URL + '/User/NewMembershipInsert', mosa)
            .then(function (response) {
                console.log(JSON.stringify(response));
                // self.redirectToValidate();
                self.setState({ isActive: false });

                if (response.status === 200) {
                    if (response.data[0].StatusCode == "0") {
                        Swal.fire({
                            title: 'Success',
                            text: 'Your membership request is submitted',
                            icon: 'success',
                            confirmButtonText: 'Ok'
                        }).then((result) => {
                            if (result.value) {
                                localStorage.setItem('enableeditprofile', true);
                                self.props.history.push('/welcome');
                            }
                        })
                    } else {
                        Swal.fire({
                            title: 'Error!',
                            text: response.data[0].Message,
                            icon: 'error',
                            confirmButtonText: 'Ok'
                        })
                    }


                } else {
                    Swal.fire({
                        title: 'Error!',
                        text: 'Please try again later!',
                        icon: 'error',
                        confirmButtonText: 'Ok'
                    })
                }

            })
            .catch(function (error) {
                console.log(error);
                self.setState({ isActive: false });
                Swal.fire({
                    title: 'Error!',
                    text: 'Please try again later!',
                    icon: 'error',
                    confirmButtonText: 'Ok'
                })

            });




    }
    createevent = () => {
        this.props.history.push('/createevent');

    }
    eventDetails = (e, eid, sid) => {
        this.props.history.push({
            pathname: '/details',
            state: { eventid: eid, stadiumid: sid }
        });

    }

    notify = () => {

        this.props.history.push('/pricing');

    }

    componentDidMount() {
        console.log("UST************** " + localStorage.getItem("usertype"));
        if (localStorage.getItem("usertype") != "User") {

            if (this.props.location.state != null) {
                localStorage.setItem("userid", this.props.location.state.userid);
                localStorage.setItem(ACCESS_TOKEN_NAME, this.props.location.state.sessionid);
            }

            headers.UserID = localStorage.getItem('userid');
            headers.SessionId = localStorage.getItem(ACCESS_TOKEN_NAME);

            let self = this; //  declared var welcom

            this.setState({ isActive: true });
            const mosa = { ReqHead: headers }
            console.log('calling events list ....' + JSON.stringify(mosa));


            axios.post(API_MOSA_URL + '/Company/GetMyEventList', mosa)

                .then(function (response) {
                    console.log(JSON.stringify(response.data));
                    // self.redirectToValidate();
                    self.setState({ isActive: false });

                    if (response.status === 200) {

                        if (response.data[0].StatusCode == "0") {

                            self.setState({ events: response.data[1] });
                            window.scrollTo(0, 0);

                        } else {
                            Swal.fire({
                                title: 'Error!',
                                text: response.data[0].Message,
                                icon: 'error',
                                confirmButtonText: 'Ok'
                            })
                        }

                    } else {
                        Swal.fire({
                            title: 'Error!',
                            text: 'Please try again later!',
                            icon: 'error',
                            confirmButtonText: 'Ok'
                        })
                    }

                })
                .catch(function (error) {
                    console.log(error);
                    self.setState({ isActive: false });
                    Swal.fire({
                        title: 'Error!',
                        text: 'Please try again later!',
                        icon: 'error',
                        confirmButtonText: 'Ok'
                    })

                });
        } else {
            this.props.history.push('/welcome');

        }

    }

    render() {
        

        let self = this;
        store.subscribe(() => {
            console.log('change lang' + store.getState().lang);
            localStorage.setItem('lang', store.getState().lang)

            self.setState({ lang: localStorage.getItem('lang') });
        });
        let commentNodes = this.state.events.map(function (event, index) {
            var check = moment(event.date_from.split(' ')[0], 'MM/DD/YYYY');

            var month = check.format('MMM');
            var day = check.format('D');
            if (index < 5) {
                return <li>
                    <time dateTime="">
                        <span className="day">{day}</span>
                        <span className="month">{month}</span>
                        <span className="year">2014</span>
                        <span className="time">ALL DAY</span>
                    </time>

                    <div className="info" style={{ padding: '5px' }}>
                        <h2 className="title">{event.event_name}</h2>
                        <p className="" style={{ padding: '10px' }}>{event.event_description}</p>

                        <p className="text-muted" style={{ marginLeft: '10px' }}>
                            <span class="badge badge-pill badge-warning" style={{ marginRight: '5px' }}>{event.approve_status}</span>
                            <span className="fa fa-map-marker" />  {event.stadium_name_en}</p>

                    </div>
                    <div className="social">
                        <ul>
                            <li className="facebook" >

                                <button className="btn btn-primary" onClick={e => self.eventDetails(e, event.event_id, event.stadium_id)} style={{ width: '100%', height: '80%' }}
                                ><span style={{ color: 'lightgrey' }}>Details</span>
                                </button>
                            </li>
                        </ul>
                    </div>
                </li>




            }
        });

        return (
            <LoadingOverlay
                active={this.state.isActive}
                spinner
                text='Loading ...'
            >

                <div style={{ backgroundColor: 'lightgrey' }}>
                    <Navbar page={5} />
                    <div className="all-title-box">
                        <div className="container text-center">
                            <h1  style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK27', this.state.lang)}<span className="m_1">{i18n.t('JK37', this.state.lang)}</span></h1>
                        </div>
                    </div>

                   
                        <div className="container rounded bg-white mt-5 mb-5">
                            <div className="row">
                            <div className="col-md-4">
                                    <div className="p-3 py-5">
                                        <div className="d-flex flex-column align-items-center text-center  border" style={{padding:'5px'}}>
                                            <img src="https://bootdey.com/img/Content/avatar/avatar7.png" alt="Admin" className="rounded-circle" style={{ maxWidth: '30%' }} />
                                            <hr />
                                            <div className="mt-3">
                                                <h4  style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK30', this.state.lang)} {localStorage.getItem('username')} !</h4>
                                                <p className="text-secondary mb-1"  style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK19', this.state.lang)}</p>
                                                <p className="text-secondary mb-1"  style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK31', this.state.lang)} {localStorage.getItem('userEmail')}</p>
                                                <p className="text-secondary mb-1"  style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK32', this.state.lang)} {localStorage.getItem('userPhone')}</p>

                                            </div>
                                        </div>
                                        

                                        {/* <hr /><div className="d-flex flex-row mt-3 exp-container">
                                            <div className="row">
                                                <div className="col-sm-3">
                                                    <h6 className="mb-0"> Name</h6>
                                                </div>
                                                <div className="col-sm-9 text-secondary">
                                                    {localStorage.getItem('username')}
                                                </div>
                                            </div>
                                            <hr />
                                            <div className="row">
                                                <div className="col-sm-3">
                                                    <h6 className="mb-0">Email</h6>
                                                </div>
                                                <div className="col-sm-9 text-secondary">
                                                    {localStorage.getItem('userEmail')}
                                                </div>
                                            </div>
                                        </div> */}

                                        
                                        <div className="inner-hmv border text-center ">
                                            <h3  style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK34', this.state.lang)}</h3>
                                            <div className="tr-pa"></div>
                                            <p  style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK35', this.state.lang)}</p>
                                            <hr />
                                            <a className="hover-btn-new log orange" href="/createevent"  style={{ fontFamily: 'Tajawal' }}><span style={{ color: 'grey' }}>{i18n.t('JK34', this.state.lang)}</span></a>



                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-8 border-right">
                                    <div className="p-3 py-5">
                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                            <h4 className="text-right"  style={{ fontFamily: 'Tajawal !important' }}>{i18n.t('JK29', this.state.lang)}</h4>
                                        </div>
                                        {this.state.events.length == 0 &&
                                            <div className="alert alert-custom alert-warning fade show mb-5" role="alert">
                                                <div className="alert-icon">
                                                    <i className="flaticon-warning" />
                                                </div>
                                                <div className="alert-text"  style={{ fontFamily: 'Tajawal' }}>{i18n.t('JK175', this.state.lang)}</div>
                                                <div className="alert-close">
                                                    <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                                                        <span aria-hidden="true">
                                                            <i className="ki ki-close" />
                                                        </span>
                                                    </button>
                                                </div>
                                            </div>
                                        }
                                        <ul className="event-list">

                                            {commentNodes}
                                        </ul>
                                    </div>
                                </div>

                            </div>
                        </div>

                   


                    <Footer />
                </div>
            </LoadingOverlay>
        )
    }
}
export default withRouter(UserProfile);
